/*
 * @Author: cn1994
 * @Date: 2022-08-10 16:34:33
 * @LastEditors: cn1994
 * @LastEditTime: 2022-08-10 16:45:02
 * @Description: 企业微信注入
 */


import { getWxJsapiSignature } from '@/apis/wx'

// config注入
export const wxConfig = params => {
	return new Promise((resolve, reject) => {
		wx.config({
			beta: true, // 必须这么写，否则wx.invoke调用形式的jsapi会有问题
			debug: params.debug, // 开发与测试环境开启调试模式
			appId: params.appId, // 必填，企业微信的corpID
			timestamp: params.timestamp, // 必填，生成签名的时间戳
			nonceStr: params.nonceStr, // 必填，生成签名的随机串
			signature: params.signature, // 必填，签名
			jsApiList: ['getContext'], // 必填，需要使用的JS接口列表
			fail: function () {
				reject(false)
			}
		})
		wx.ready(function () {
			console.log('wxready')
			resolve(true)
		})
		wx.error(function (res) {
			console.log('error-res', res)
			// if (res.errMsg.include('config:check failed')) {
			// 	alert('code: 10005')
			// }
			reject(false)
		})
	})
}

// 注入agentConfig

export const wxAgentConfig = params => {
	return new Promise((resolve, reject) => {
		wx.agentConfig({
			debug: params.debug, // 开发与测试环境开启调试模式
			corpid: params.corpId, // 必填，企业微信的corpid，必须与当前登录的企业一致
			agentid: params.agentid, // 必填，企业微信的应用id （e.g. 1000247）
			timestamp: params.timestamp, // 必填，生成签名的时间戳
			nonceStr: params.nonceStr, // 必填，生成签名的随机串
			signature: params.signature, // 必填，签名，见附录-JS-SDK使用权限签名算法
			jsApiList: [
				'shareAppMessage',
				'getContext',
				'selectEnterpriseContact',
				'onMenuShareWechat',
				'onMenuShareAppMessage',
				'onMenuShareTimeline'
			], //必填，传入需要使用的接口名称
			success: function () {
				resolve(true)
			},
			fail: function (res) {
				if (res.errMsg.indexOf('function not exist') > -1) {
					alert('code: 10004')
				} else if (res.errMsg.include('config:check failed')) {
					alert('code: 10006')
				}
				reject(false)
			}
		})
	})
}

/**
 * Sets the WxConfig for a given openUserId and corpId.
 *
 * @param {Object} params - 参数
 * @param {string} params.openUserId - 用户的唯一标识.
 * @param {string} params.corpId - 企业微信的corpid
 * @returns {Promise, Boolean} - 返回是否设置成功
 */
export const setWxConfig = async ({ openUserId, corpId }) => {
  let debug = false

  const params = {
    openUserId,
    corpId,
    url: window.location.href.split('#')[0],
  };

  const res = await getWxJsapiSignature(params);

  if (res.code != 0) {
    alert('code: 10001');
    return false;
  }

  if (res.data.wxJsapiSignature) {
    try {
      const data = await wxConfig({ ...res.data.wxJsapiSignature, debug });
      console.log(`wxConfig ${data}`);
    } catch (error) {
      console.log('wxconfig-error:', error);
      return false;
    }
  }

  if (res.data.wxAgentJsapiSignature) {
    try {
      await wxAgentConfig({ ...res.data.wxAgentJsapiSignature, debug });
      console.log('wxAgentconfig success');
    } catch (error) {
      return false;
    }
  }

  return true;
};

